<a [routerLink]="" class="label"
  (click)="opAtivoDetalhes.toggle($event)"
  [ngClass]="{ 'label-success': sucesso, 'label-danger': !sucesso }">
  {{ativo.nome}}
</a>

<p-overlayPanel #opAtivoDetalhes appendTo="body">
  <ng-template pTemplate>
    <table class="itens-detalhes">
      <tr *ngFor="let item of ativo.itens">
        <th>{{item.nome}}: </th>
        <td>
          <span class="label {{getItemClasse(item)}}">
            {{item.getSituacaoDescricao()}}
          </span>
          <div *ngIf="item.isFalha()" class="item-erro">
            {{item.erro}}
          </div>
        </td>
      </tr>
    </table>
  </ng-template>
</p-overlayPanel>
